// extracted by mini-css-extract-plugin
export default {"root":"IconWebPage_root__o4Zk1"};